import FormattedMessage from 'I18n/components/FormattedMessage';
import UIPanelSection from 'UIComponents/panel/UIPanelSection';
import UITable from 'UIComponents/table/UITable';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { DEFAULT_BRANCH_INDEX } from 'automation-ui-action-features/records/recordsUtils';
import EnrollmentConversionPanelBranchRow from 'automation-ui-canvas/containers/enrollment-conversion/panel/table/EnrollmentConversionPanelBranchRow';
import { useGetActionOutputsForTargetActionById } from 'automation-ui-canvas/flow/hooks/actionOutputHooks';
import { getEdgeIdForAction } from 'automation-ui-canvas/utils/getEdgeIdForAction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollmentConversionPanelBranchTableContent = ({
  currentVersionGroupFlow,
  orderedActions,
  getHeaderTitle,
  enrollmentConversionData,
  isReportingEnabled
}) => {
  const getActionOutputsForTargetActionById = useGetActionOutputsForTargetActionById(currentVersionGroupFlow);
  const branchActions = orderedActions.filter(action => {
    return action.isBranch();
  });
  return /*#__PURE__*/_jsx(UIPanelSection, {
    className: "m-bottom-0 p-all-0",
    children: branchActions.map(action => {
      const connection = action.getConnection();
      const branches = connection.getBranches();
      return /*#__PURE__*/_jsxs(UITable, {
        responsiveWrapperClassName: "m-bottom-0",
        style: {
          borderBottom: 'none'
        },
        hover: false,
        children: [/*#__PURE__*/_jsxs("colgroup", {
          children: [/*#__PURE__*/_jsx("col", {
            style: {
              width: '75%'
            }
          }), /*#__PURE__*/_jsx("col", {
            style: {
              width: '25%'
            }
          })]
        }), /*#__PURE__*/_jsx("thead", {
          children: /*#__PURE__*/_jsx(UITooltip, {
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "automation.enrollmentConversion.panel.tooltips.branchHeader"
            }),
            children: /*#__PURE__*/_jsxs("tr", {
              children: [/*#__PURE__*/_jsx("th", {
                children: getHeaderTitle({
                  actionId: action.getActionId()
                })
              }), /*#__PURE__*/_jsx("th", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "automation.enrollmentConversion.panel.branchTable.conversion"
                })
              })]
            })
          })
        }), /*#__PURE__*/_jsxs("tbody", {
          children: [branches.map((branch, branchIndex) => {
            const branchEdgeId = getEdgeIdForAction(action.getActionId(), branchIndex);
            return /*#__PURE__*/_jsx(EnrollmentConversionPanelBranchRow, {
              action: action,
              index: branchIndex,
              edgeId: branchEdgeId,
              enrollmentConversionData: enrollmentConversionData,
              flow: currentVersionGroupFlow,
              isReportingEnabled: isReportingEnabled,
              handleGetActionOutputsForTargetActionById: getActionOutputsForTargetActionById
            }, branchEdgeId);
          }), (action.isListBranch() || action.isStaticBranch()) && /*#__PURE__*/_jsx(EnrollmentConversionPanelBranchRow, {
            action: action,
            index: DEFAULT_BRANCH_INDEX,
            edgeId: getEdgeIdForAction(action.getActionId(), DEFAULT_BRANCH_INDEX),
            enrollmentConversionData: enrollmentConversionData,
            flow: currentVersionGroupFlow,
            handleGetActionOutputsForTargetActionById: getActionOutputsForTargetActionById,
            isReportingEnabled: isReportingEnabled
          })]
        })]
      }, action.getActionId());
    })
  });
};
export default EnrollmentConversionPanelBranchTableContent;